export enum ApartmentSearchSortType {
	TotalPrice = 1,
	Layout = 2,
	FloorLevel = 3,
	FloorArea = 4,
	CompletionDate = 5,
	LocationName = 6,
	HousingBlockName = 7,
	Orientation = 8,
	StateNew = 9,
	StatePromotion = 10,
	FloorAreaPrice = 11
}
